// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Sdia7-cUlb6VR-NOVgr8r"};